import { render, staticRenderFns } from "./version.vue?vue&type=template&id=3a3e261c&scoped=true&"
import script from "./version.vue?vue&type=script&lang=ts&"
export * from "./version.vue?vue&type=script&lang=ts&"
import style0 from "./version.vue?vue&type=style&index=0&id=3a3e261c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e261c",
  null
  
)

export default component.exports